import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Divider,
  Link,
  Container,
  SxProps,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import AppleIcon from "@mui/icons-material/Apple";

const socialButtons = [
  { icon: GoogleIcon, text: "Continue with Google" },
  { icon: MicrosoftIcon, text: "Continue with Microsoft Account" },
  { icon: AppleIcon, text: "Continue with Apple" },
];

const buttonSx: SxProps = {
  height: "50px",
  textTransform: "none",
};

const Signup: React.FC = () => {
  return (
    <Container maxWidth="xs">
      <Box display="flex" flexDirection="column" alignItems="center" py={4}>
        <img
          src="logo.png"
          alt="Logo"
          width={70}
          style={{ marginBottom: "80px" }}
        />
        <Typography variant="h4" gutterBottom>
          Create an account
        </Typography>
        <TextField
          label="Email address"
          variant="outlined"
          fullWidth
          required
          margin="normal"
        />
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ ...buttonSx, my: 2 }}
        >
          Continue
        </Button>
        <Typography variant="body2" gutterBottom>
          Already have an account? <Link href="/login">Login</Link>
        </Typography>
        <Divider sx={{ width: "100%", my: 2 }}>OR</Divider>
        {socialButtons.map(({ icon: Icon, text }) => (
          <Button
            key={text}
            variant="outlined"
            startIcon={<Icon />}
            fullWidth
            sx={{ ...buttonSx, mb: 1 }}
          >
            {text}
          </Button>
        ))}
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ mt: 10, mb: 5 }}
        >
          <Link href="/terms">Terms of Use</Link> |{" "}
          <Link href="/privacy">Privacy Policy</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Signup;
